/* Owlkrown homepage video gate.
 *
 * The homepage carries ten videos in explainer bands. Left alone they all
 * autoplay at once, which is the thing that makes a page feel busy, so this
 * lets ONLY ONE play: the most visible one wins and every other one stops.
 *
 * Lived inline in the custom_liquid of the custom_liquid_video_gate section
 * until 2026-10-11. It is an asset now, so editing it is a 4KB write instead
 * of a 58KB rewrite of templates/index.json.
 */
(function () {
  if (!('IntersectionObserver' in window)) return;

  var PLAY_AT = 0.35;   /* a band clipping the fold by a sliver must not start */
  var BEST    = 0.45;   /* where the "best image" sits, as a fraction of length */
  var FADE    = 420;
  var gated   = [];

  function vis(v) {
    var r = v.getBoundingClientRect(), vh = window.innerHeight || 0;
    if (!r.height) return 0;
    return Math.max(0, Math.min(r.bottom, vh) - Math.max(r.top, 0)) / r.height;
  }

  /* Stopping a video leaves whatever frame it happened to be on, which is
     usually a blur mid-move. Fade it down, seek to a chosen frame, fade it
     back: it settles on a still worth looking at instead of freezing. */
  function settle(v) {
    v.style.transition = 'opacity ' + (FADE / 1000) + 's ease';
    v.style.opacity = '0';
    window.setTimeout(function () {
      try { if (v.duration && isFinite(v.duration)) v.currentTime = v.duration * BEST; } catch (e) {}
      v.style.opacity = '1';
    }, FADE);
  }

  /* Pausing a video whose play() has been requested but has not begun rejects
     that pending promise with an AbortError. The theme starts its own videos
     and does not catch, so those rejections landed in the console uncaught:
     about 16 on every homepage load, purely from this gate stopping the nine
     videos it does not want.

     The trick is to ask for play() ourselves and pause in its callback. On a
     video that is already running that resolves immediately and does not
     restart it; on one that is still starting it settles with the SAME
     outcome as the pending call, so by the time we pause, that call has
     already resolved and there is nothing left to abort. Watching for the
     play event instead does not work: the event is queued as a task, so
     there is a window where paused is false and the event has not landed. */
  function stop(v) {
    if (v.paused || v.okStopping) return;
    var p = v.play();
    if (!p || !p.then) { v.pause(); settle(v); return; }
    v.okStopping = true;
    p.then(function () {
      v.okStopping = false;
      if (v.okKeepPlaying) return;   /* it won the screen while we waited */
      v.pause();
      settle(v);
    }, function () { v.okStopping = false; });
  }

  /* its own function so the catch closes over THIS video: the loop below uses
     var, so a handler written inline there would see only the last one */
  function start(v) {
    v.style.opacity = '1';
    v.okKeepPlaying = true;
    if (!v.paused) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.setAttribute('autoplay', ''); });
  }

  /* ONLY ONE PLAYS. Two bands can share the screen while scrolling between
     them, and two moving pictures at once is the thing that makes a page feel
     busy. The most visible one wins; every other one stops and settles. */
  function update() {
    var win = null, wf = PLAY_AT;
    for (var i = 0; i < gated.length; i++) {
      var f = vis(gated[i]);
      if (f >= PLAY_AT && f >= wf) { if (f > wf || !win) { wf = f; win = gated[i]; } }
    }
    for (var j = 0; j < gated.length; j++) {
      if (gated[j] === win) { start(gated[j]); }
      else { gated[j].okKeepPlaying = false; stop(gated[j]); }
    }
  }

  var io = new IntersectionObserver(update, { threshold: [0, PLAY_AT, 0.7, 1] });
  var tick = null;
  function onScroll() {
    if (tick) return;
    tick = window.setTimeout(function () { tick = null; update(); }, 120);
  }

  function attach() {
    var vs = document.querySelectorAll('video'), added = false;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if (v.getAttribute('data-ok-gated')) continue;
      v.setAttribute('data-ok-gated', '1');
      /* The autoplay attribute is deliberately left in place. Stripping it makes
         this gate the only thing that can start a video, so a browser that
         refuses a scripted play() would show a frozen frame forever. */
      v.okKeepPlaying = false;
      if (vis(v) < PLAY_AT) stop(v);
      gated.push(v); io.observe(v); added = true;
    }
    if (added) update();
  }

  function boot() {
    attach();
    new MutationObserver(attach).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
